





































































































































































































































// @ts-nocheck
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import bulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import addModal from './addModal.vue';
import logModal from './logModal.vue';
import { Moment } from 'moment';

@Component({
  components: {
    bulkSearchModal,
    addModal,
    logModal,
  },
})
export default class AdditionalServicesConfigListPage extends Vue {
  /** 搜索条件 */
  protected searchData: TypeAdditionalServicesConfig.SearchData = this.initSearchData();
  /** 搜索类型 */
  protected searchTypes: TypeAdditionalServicesConfig.SearchTypes = this.initSearchTypes();
  /** 加载状态 */
  protected loadingStatus: boolean = false;
  /** 总数 */
  protected total: number = 0;
  /** 列表数据 */
  protected dataList: TypeAdditionalServicesConfig.ListItem[] = [];
  /** 表格列 */
  protected columns: TypeBase.TableColumn[] = [];
  /** 选中列表 */
  protected selectedList: TypeAdditionalServicesConfig.ListItem[] = [];
  /** 状态列表 */
  protected statusList: TypeBase.EnumListItem[] = [
    { text: this.t('启用'), value: this.$enum.product.AdditionalServicesConfigStatusEnum.ENABLE },
    { text: this.t('停用'), value: this.$enum.product.AdditionalServicesConfigStatusEnum.DISABLE },
  ];
  /** 时间类型列表 */
  protected timeTypeList: TypeBase.EnumListItem[] = [
    { text: this.t('创建时间'), value: this.$enum.product.AdditionalServicesConfigTimeTypeEnum.CREATE_TIME },
    { text: this.t('更新时间'), value: this.$enum.product.AdditionalServicesConfigTimeTypeEnum.UPDATE_TIME },
  ];
  /** 附加服务项列表 */
  protected additionalServiceItemList: TypeBase.EnumListItem[] = [];
  /** 仓库列表 */
  protected warehouseList: TypeCommon.AllWarehouseListItem[] = [];
  /** 表格行选择配置 */
  protected rowSelection: TypeBase.RowSelection = {};
  /** 新增/编辑弹窗显示状态 */
  protected addModalVisible: boolean = false;
  /** 编辑数据 */
  protected editRowData: TypeAdditionalServicesConfig.ListItem | null = null;
  /** 日志记录 */
  protected logRecord: TypeAdditionalServicesConfig.ListItem | null = null;

  /**
   * 初始化搜索条件
   */
  @userPrefPageSize('additionalServicesConfigList')
  protected initSearchData(): TypeAdditionalServicesConfig.SearchData {
    return {
      status: undefined, // 全部
      product_sku_list: undefined,
      product_barcode_list: undefined,
      additional_service_code: undefined,
      warehouse_code: undefined,
      product_name: undefined,
      start_time: undefined,
      end_time: undefined,
      time_type: undefined,
      page_index: 1,
      page_size: 20
    };
  }

  /**
   * 设置表格列
   */
  protected setColumns(): void {
    this.columns = [
      {
        title: this.t('商品编码'),
        dataIndex: 'product_sku',
        name: 'product_sku',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('谷仓商品编码'),
        dataIndex: 'product_barcode',
        name: 'product_barcode',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('中文名称'),
        dataIndex: 'product_name',
        name: 'product_name',
        isCopy: true,
        filterEmpty: true,
      },
      {
        title: this.t('附加服务项'),
        dataIndex: 'additional_service_item_list',
        name: 'additional_service_item_list',
        scopedSlots: { customRender: 'additional_service_item_list'},
        filterEmpty: true,
      },
      {
        title: this.t('适用仓库(区域)'),
        name: 'warehouse_item_list',
        scopedSlots: { customRender: 'warehouse_item_list' },
      },
      {
        title: this.t('状态'),
        dataIndex: 'status_text',
        name: 'status_text',
        scopedSlots: { customRender: 'status_text' },
      },
      {
        title: this.t('时间'),
        name: 'time',
        width: 200,
        scopedSlots: { customRender: 'time' },
      },
      {
        title: this.t('操作'),
        name: 'operation',
        fixed: 'right',
        width: 200,
        scopedSlots: { customRender: 'operation' },
      },
    ];
  }

  /**
   * 查询列表
   */
  @loading('loadingStatus')
  protected async queryList(): Promise<void> {
    const postData = this.formatParams();
    this.loadingStatus = true;
    try {
      const { data } = await this.$api.product.queryAdditionalServicesConfigList(postData);
      this.dataList = data.list || [];
      this.total = +data.total || 0;
    } finally {
      this.loadingStatus = false;
    }
  }

  /**
   * 格式化查询参数
   */
  protected formatParams(): TypeAdditionalServicesConfig.SearchData {
    const postData = {
      ...this.searchData
    };
    // 编码
    if (this.searchTypes.codeTypeValue) {
      const resStr = this.searchTypes.codeTypeValue;
      const resStrArr = resStr.split(',').filter((item: string) => item && item.trim());
      if (resStrArr.length) {
        postData[this.searchTypes.codeType] = resStrArr;
      }
    }
    

    // 中文名称
    if (this.searchTypes.langTypeValue) {
      postData[this.searchTypes.langType] = this.searchTypes.langTypeValue;
    }
    
    // 时间
    if (this.searchTypes.timeTypeValue && this.searchTypes.timeTypeValue.length === 2) {
      postData.start_time = this.$util.formatDateTime(this.searchTypes.timeTypeValue[0]);
      postData.end_time = this.$util.formatDateTime(this.searchTypes.timeTypeValue[1]);
      // time_type: 0-创建时间，1-更新时间
      postData.time_type = this.searchTypes.timeType;
    }

    return postData;
  }

  /**
   * 搜索
   */
  protected handleSearch(): void {
    this.searchData.page_index = 1;
    this.queryList();
  }

  protected initSearchTypes(): TypeAdditionalServicesConfig.SearchTypes {
    return {
      codeType: 'product_sku_list',
      codeTypeValue: '',
      langType: 'product_name',
      langTypeValue: '',
      timeType: 1, // 0-创建时间，1-更新时间
      timeTypeValue: this.$util.getDefaultTimeCondition(),
    };
  }
  /**
   * 重置
   */
  protected handleReset(): void {
    this.searchData = this.initSearchData();
    this.searchTypes = this.initSearchTypes();
    this.queryList();
  }

  /**
   * 切换状态tab
   */
  protected handleTabChange(): void {
    this.initPage();
    this.queryList();
  }
  protected initPage(): void {
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
    this.searchData.page_index = 1;
  }

  /**
   * 双击批量查询
   */
  protected handleDblClick(): void {
    const bsM = this.$refs.bulkSearchModal as any;
    bsM.modalVisible = true;
    bsM.bulkListStr = this.searchTypes.codeTypeValue;
  }

  /**
   * 批量搜索反馈
   */
  protected handleBulkFeedback(bulkKeywords: string): void {
    this.searchTypes.codeTypeValue = bulkKeywords;
  }

  /**
   * 分页变化
   */
  protected handlePageChange(pageIndex: number, pageSize: number): void {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryList();
  }

  /**
   * 新增规则
   */
  protected handleAdd(): void {
    this.editRowData = null;
    this.addModalVisible = true;
  }

  /**
   * 新增/编辑成功回调
   */
  protected handleAddSuccess(): void {
    this.queryList();
  }

  /**
   * 编辑
   * @param record 列表项数据
   */
  protected handleEdit(record: TypeAdditionalServicesConfig.ListItem): void {
    this.editRowData = record;
    this.addModalVisible = true;
  }

  /**
   * 停用
   */
  protected handleDisable(record: TypeAdditionalServicesConfig.ListItem): void {
    this.$confirm({
      title: this.t('温馨提示'),
      content: this.t('确认停用该规则？'),
      onOk: async () => {
        try {
          await this.$api.product.changeAdditionalServicesConfigStatus({
            id: record.id,
            status: this.$enum.product.AdditionalServicesConfigStatusEnum.DISABLE,
          });
          this.$message.success(this.t('操作成功'));
          this.queryList();
        } catch (error) {
          // 错误已在api层处理
        }
      },
    });
  }

  /**
   * 启用
   */
  protected handleEnable(record: TypeAdditionalServicesConfig.ListItem): void {
    this.$confirm({
      title: this.t('温馨提示'),
      content: this.t('确认启用该规则？'),
      onOk: async () => {
        try {
          await this.$api.product.changeAdditionalServicesConfigStatus({
            id: record.id,
            status: this.$enum.product.AdditionalServicesConfigStatusEnum.ENABLE,
          });
          this.$message.success(this.t('操作成功'));
          this.queryList();
        } catch (error) {
          // 错误已在api层处理
        }
      },
    });
  }

  /**
   * 查看日志
   * @param record 列表项数据
   */
  protected handleLog(record: TypeAdditionalServicesConfig.ListItem): void {
    this.logRecord = record;
    const logModalRef = this.$refs.logModal as any;
    if (logModalRef) {
      logModalRef.visible = true;
    }
  }

  /**
   * 导出全部
   */
  protected async handleExportAll(): Promise<void> {
    const postData = this.formatParams();
    delete postData.page_index;
    delete postData.page_size;
    const { code, data, message } = await this.$api.product.exportAdditionalServicesConfig<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }

  /**
   * 导出已选
   */
  protected async handleExportSelected(): Promise<void> {
    if (!this.selectedList.length) {
      this.$message.warning(this.t('请选择导出项'));
      return;
    }
    const postData = {
      id_list: this.selectedList.map(item => item.id),
    };
    const { code, data, message } = await this.$api.product.exportAdditionalServicesConfig<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }

  /**
   * 查询仓库列表
   */
  protected async queryWarehouseList(): Promise<void> {
    const res = await this.$api.common.queryAllWarehouseList();
    this.warehouseList = res.data;
  }

  /**
   * 查询附加服务项列表
   */
  protected async queryAdditionalServiceItemList(): Promise<void> {
    try {
      const { data } = await this.$api.product.queryServiceItemList({});
      const list = data?.list || [];
      // 转换为 EnumListItem 格式
      this.additionalServiceItemList = list.map(item => ({
        text: item.service_name,
        value: item.service_code,
      }));
    } catch (error) {
      // 错误已在api层处理
      this.additionalServiceItemList = [];
    }
  }

  /**
   * 表格行选择变化
   */
  protected onSelectChange(selectedRowKeys: string[], selectedRows: TypeAdditionalServicesConfig.ListItem[]): void {
    this.rowSelection.selectedRowKeys = selectedRowKeys;
    this.selectedList = selectedRows;
  }

  protected created(): void {
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: this.onSelectChange,
    };
    this.setColumns();
    this.queryList();
    this.queryWarehouseList();
    this.queryAdditionalServiceItemList();
  }
}
